import { Tabs } from "antd";

const Component = ({ ...props }) => (
  <div className="custom--tab">
    <Tabs {...props} />
  </div>
);

export default Component;
